import React, { useContext, useEffect } from 'react'
import { FilterWrapper } from '../style';
import { Dropdown, Input } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { FarmerContext } from '../FarmerProviderComp';
import { FarmersOptionsType } from '~/api/services/farmers/index';
import { useDebounce } from 'use-lodash-debounce';
import dayjs from 'dayjs';
import CustomInput from '~/components/CustomInput';
import LocationFilters from './LocationFilters';

interface FiltersProps {
  dataFiltered: any
  handleChangeData: (data: any) => void
  farmersListOptions: FarmersOptionsType
}

const Filters: React.FC<FiltersProps> = (props) => {
  const { t } = useTranslation()
  const { dataFiltered, handleChangeData, farmersListOptions } = props
  const {
    contextValues,
    contextValues: {
      filterInputValues,
      search,
      checkedFilters
    },
    setContextValues
  } = useContext(FarmerContext)
  const debouncedFilterInputValues = useDebounce(filterInputValues, 300)
  const debouncedValue = useDebounce(search, 300);

  useEffect(() => {
    handleChangeData({ ...dataFiltered, search: debouncedValue, page: 0 });
  }, [debouncedValue]);

  useEffect(() => {
    handleChangeData({ ...dataFiltered, ...debouncedFilterInputValues });
  }, [debouncedFilterInputValues])

  function getTextOptionDropdownFilter(key, item) {
    switch (key) {
      case 'milkTypeId':
        return `${item?.abbreviation} (${item?.name})`
      case 'districtId':
        return `${item?.name} / ${item?.zip}`
      default:
        return item.name
    }
  }

  function renderInputFilter(filter) {
    return <CustomInput
      key={filter.key}
      style={{ maxWidth: 200, width: 200 }}
      value={filterInputValues[filter.key]}
      placeholder={filter.placeholder}
      onChange={(value) => setContextValues({
        ...contextValues,
        filterInputValues: {
          ...contextValues.filterInputValues,
          [filter.key]: value
        }
      })
      }
    />
  }

  function getOptions(filter) {
    switch(filter.key) {
      case 'periods':
        return farmersListOptions[filter?.optionsKey]?.map(period => ({
          text: `${dayjs(period.periodFrom).format('DD.MM.YYYY')} - ${dayjs(period.periodTo).format('DD.MM.YYYY')}`,
          value: `${period.periodFrom}/${period.periodTo}`
        }));
      default:
        return filter.options || farmersListOptions[filter?.optionsKey]?.map(item => (
          {
            value: item?.id,
            text: getTextOptionDropdownFilter(filter.key, item)
          }
        ))
    }
  }

  function handleOnChangeDropdown(filter, value) {
    switch(filter.key) {
      case 'periods':
        // eslint-disable-next-line
        const periods = value ? value.toString().split('/') : ['', '']
        return handleChangeData({
          ...dataFiltered,
          periodFrom: periods[0],
          periodTo: periods[1]
        })
      default:
        return handleChangeData({
          ...dataFiltered,
          [filter.key]: value
        })
    }
  }

  function renderDropdownFilter(filter) {
    const options = getOptions(filter)

    if(filter.key === 'stateId') {
      return <LocationFilters
        dataFiltered={dataFiltered}
        handleChangeData={handleChangeData}
        farmersListOptions={farmersListOptions}
      />
    }

    return <Dropdown
      key={filter.key}
      placeholder={filter.placeholder}
      value={dataFiltered[filter.key]}
      clearable
      noResultsMessage={t('No results found....')}
      style={{ width: 220 }}
      options={options}
      onChange={(e, data) => handleOnChangeDropdown(filter, data.value)}
      selection
      selectOnBlur={false}
    />
  }

  return (
    <FilterWrapper>
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('Search...')}
        value={search}
        style={{ marginRight: 10, width: 200 }}
        onChange={(e, data) => setContextValues({
          ...contextValues,
          search: data.value
        })}
      />
      <Dropdown
        placeholder={t('Select farmer group')}
        clearable
        options={farmersListOptions?.farmerGroups.map((farmerGroup) => ({
          value: farmerGroup.id,
          text: farmerGroup.name
        }))}
        value={dataFiltered.farmerGroupId}
        onChange={(e, data) =>
          handleChangeData({
            ...dataFiltered,
            farmerGroupId: data.value
          })
        }
        style={{ marginBottom: 5, marginRight: 10 }}
        selection
        selectOnBlur={false}
      />
      {checkedFilters.map(checkedFilter => {
        return checkedFilter.options || checkedFilter?.optionsKey ? renderDropdownFilter(checkedFilter) : renderInputFilter(checkedFilter)
      })}
    </FilterWrapper>
  );
}
export default Filters